import { create } from 'zustand'

/**
 * Devices the host has personally let this participant use while the room
 * switch for them is off: set when the participant accepts Request Audio /
 * Request Video, cleared when the host mutes them individually, when the room
 * switch changes, and when a meeting screen mounts.
 *
 * Local to this browser on purpose: the room switches themselves are honoured
 * by the client, not the server, and a rejoin starts the person back under the
 * room's rule, which the host can lift again with another request.
 */
type DeviceGrantState = {
  audio: boolean
  video: boolean
  grant: (kind: 'audio' | 'video') => void
  revoke: (kind: 'audio' | 'video') => void
  clear: () => void
}

export const useDeviceGrantStore = create<DeviceGrantState>((set) => ({
  audio: false,
  video: false,
  grant: (kind) => set({ [kind]: true } as Partial<DeviceGrantState>),
  revoke: (kind) => set({ [kind]: false } as Partial<DeviceGrantState>),
  clear: () => set({ audio: false, video: false }),
}))
